export const LOCAL_STORAGE_KEYS = {
  LANGUAGE: 'language',
  ACCESS_TOKEN: 'megagen-access_token',
  ROLE_TYPE: 'megagen-role_type',
};
